import { makeStyles } from '@material-ui/core';

export const useConnectionPageStyles = makeStyles(theme => ({
  layout: {
    display: 'grid',
    gap: theme.spacing(3),
    maxWidth: 760,
  },
  section: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  group: {
    display: 'grid',
    gap: theme.spacing(1),
  },
  liveRegion: {
    color: theme.palette.text.secondary,
  },
  // Accessible but not painted: the chip already shows the canonical state.
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
}));
